// File: client/src/platform/prng.js
//
// A tiny seeded PRNG shared across variants (UNO deck shuffle, Randomizer events).
// Extracted here because ≥2 variants need deterministic randomness (deck order and
// event sequences must be reproducible for replay/resume and testable).
//
// Linear Congruential Generator — fast, dependency-free, good enough for game RNG
// (NOT cryptographic).

/**
 * @param {number} seed
 * @returns {() => number} a function returning a float in [0, 1)
 */
export function createPRNG(seed) {
  let s = seed >>> 0 || 1;
  return function next() {
    s = (s * 9301 + 49297) % 233280;
    return s / 233280;
  };
}
